import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraAvatar } from '../ensigns/avatar';
import { SpecraText } from '../ensigns/typography';
/** Visual identity row used inside person, assignee, and contact pickers. */ export const SpecraPersonOptionContent = /*#__PURE__*/ React.forwardRef(({ avatarSize = 24, avatarSrc, className, description, name, ...props }, ref)=>/*#__PURE__*/ _jsxs("span", {
        className: cn('flex min-w-0 items-center gap-[var(--space-2)]', className),
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraAvatar, {
                "aria-hidden": "true",
                name: name,
                size: avatarSize,
                src: avatarSrc
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate",
                        children: name
                    }),
                    description ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate",
                        size: "micro",
                        tone: "muted",
                        children: description
                    }) : null
                ]
            })
        ]
    }));
SpecraPersonOptionContent.displayName = 'SpecraPersonOptionContent';
